import {
  Activity01Icon,
  BalanceScaleIcon,
  BinocularsIcon,
  Building01Icon,
  Clock01Icon,
  File01Icon,
  FilterIcon,
  GridViewIcon,
  HierarchyCircle03Icon,
  MagicWand01Icon,
  ModernTvIcon,
  PauseIcon,
  Route01Icon,
  SearchIcon,
  Shield01Icon,
  SlidersHorizontalIcon,
  UserGroup03Icon,
} from '@hugeicons-pro/core-stroke-rounded'
import type { IconSvgElement } from '@hugeicons/react'
import type { AutomationChannel, CommandIconKey } from '@/lib/automations/fallback-data'

export const COMMAND_ICON: Record<CommandIconKey, IconSvgElement> = {
  sparkles: MagicWand01Icon,
  shield: Shield01Icon,
  balance: BalanceScaleIcon,
  pause: PauseIcon,
  filter: FilterIcon,
  users: UserGroup03Icon,
  sliders: SlidersHorizontalIcon,
  route: Route01Icon,
  clock: Clock01Icon,
  activity: Activity01Icon,
  binoculars: BinocularsIcon,
  file: File01Icon,
}

export const CHANNEL_ICON: Record<AutomationChannel, IconSvgElement> = {
  search: SearchIcon,
  social: UserGroup03Icon,
  tv: ModernTvIcon,
  programmatic: HierarchyCircle03Icon,
  audio: HierarchyCircle03Icon,
  retail: HierarchyCircle03Icon,
  creative: MagicWand01Icon,
  analyst: Activity01Icon,
  workspace: Building01Icon,
  all: GridViewIcon,
}

export const COMMAND_ICON_KEYS = Object.keys(COMMAND_ICON) as CommandIconKey[]
